import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/folder/entry/[entryId]/error.tsx");
